import type { IAppConfig, ICheckoutConfig } from './Config.interface'

// individual environments configs:
import configMock from './config-files/mock.json'
import configProduction from './config-files/production.json'

// shared/common stuff
import configGlobal from './config-files/shared/global.json'

export type { IAppConfig, ICheckoutConfig }

// return appropriate config based on env VUE_APP_CONFIG
let env: string = 'mock' /* by default we return the mock configuration */

// if our env VUE_APP_CONFIG variable is set, get its value
// @ts-ignore
if (process.env && process.env.NODE_ENV) {
  // @ts-ignore
  env = process.env.NODE_ENV.trim().toLowerCase()
  if (env === 'development') {
    env = 'mock'
  }
}

// example using strategy pattern:
// const configsMap: { [key: string]: IAppConfig } = {
//   mock: configMock
// }
// if (!configsMap[env]) {
//   throw Error(`Could not find config for VUE_APP_CONFIG key "${ env }"`)
// }
// export const config: IAppConfig = configsMap[env]

// config files env map
export const configsMap: Map<string, IAppConfig> = new Map<string, IAppConfig>([
  ['mock', configMock],
  ['production', configProduction],
])
if (!configsMap.has(env)) {
  throw Error(`Could not find config for VUE_APP_CONFIG key "${env}"`)
}

const item: IAppConfig = configsMap.get(env) as IAppConfig

// lower case lcid values
item.locales.default = (item.locales.default || '').trim().toLowerCase()
item.locales.enabled = (item.locales.enabled || []).map((x) => (x || '').trim().toLowerCase())
item.locales.available = (item.locales.available || []).map((x) => {
  // @ts-ignore
  x.selected = x.id === item.locales.default
  x.id = (x.id || '').trim().toLowerCase()
  return x
})

// default theme
const themes = item.themes || []
let defaultTheme = themes.find((x) => x.selected)
if (!defaultTheme) {
  // default to first
  defaultTheme = item.themes[0]
}
item.themes = themes.map((x) => {
  x.selected = x.id === defaultTheme?.id
  x.id = (x.id || '').trim().toLowerCase()
  return x
})

item.global = configGlobal
export const config = item
